$.fn.animateScroll = function(duration, options) {
  var options = options || {};

  var elem = $(this);
  var scrollTo = elem.find('.scroll-to');
  if (scrollTo.length) {
    elem = scrollTo;
  }

  var container = $(options.parent ? elem.parent() : 'html, body');

  var offset = elem.offset();

  var animation;
  switch (options.scroll) {
    case 'left':
      animation = {scrollLeft: offset.left - ((container.innerWidth() - container.width()) / 2)};
      break;
    default:
      animation = {scrollTop: offset.top - ((container.innerHeight() - container.height()) / 2)};
  }

  container.animate(animation, duration);
};